export default __webpack_public_path__ + "static/media/Averta-Bold.cdcd120f.woff";